<div [formGroup]="form" class="host-account-form">
  <ng-container>
    <div *ngIf="thirdpartyType === Platform.TuJia">
      <nz-alert
        class="tujia-info"
        [nzType]="'info'"
        [nzMessage]="'目前不支持途家子账号或子房源的同步，请使用母账号登录。'"
        nzShowIcon
      ></nz-alert>
    </div>
    <!-- <div *ngIf="thirdpartyType === Platform.MEITUAN">
      <span *ngIf="!meituanLoginStatus">
        可能没安装插件，请联系客服
      </span>
      <span *ngIf="meituanLoginStatus === 0">
        请去ebooking登录美团酒店
      </span>
      <span *ngIf="meituanLoginStatus === 1">
        登录信息： {{ meituanLoginInfo?.account | json }}
      </span>
    </div> -->
    <div class="icon">
      <div class="circle">
        <img [src]="thirdpartyInfo?.icon"/>
      </div>
      <div class="title">
        {{ 'word.channel_' + thirdpartyType | translate }}
        {{ 'word.direct_connect' | translate }}
        <!-- {{ thirdpartyInfo?.name }}直连 -->
      </div>
    </div>

    <div class="meituan-login-info"
         *ngIf="thirdpartyType === Platform.MeiTuanJiuDian && meituanLoginStatus === 1">
      <p class="meituan-login-info-t">此账号已有登录态，可正常登录。</p>
      <div class="meituan-login-info-c">
        accountId：{{ meituanLoginInfo?.account?.accountId }} accountLogin:
        {{ meituanLoginInfo?.account?.accountLogin }}
        mobile: {{ meituanLoginInfo?.account?.mobile }}
      </div>
    </div>

    <!-- 账号 -->
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <div class="create" *ngIf="editMode === EditMode.Create">
          <input
            nz-input
            nzSize="large"
            formControlName="username"
            [attr.placeholder]="'placeholder.account' | translate"
          />
        </div>
        <div class="create" *ngIf="editMode === EditMode.Update"
             style="padding-left: 5px">
          {{ username }}
        </div>
      </div>
    </div>
    <!-- 密码 -->
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row relative">
          <input
            nz-input
            nzSize="large"
            [attr.type]="passwordVisible ? 'text' : 'password'"
            formControlName="password"
            [attr.placeholder]="'placeholder.password' | translate"
          />
          <div
            class="absolute top-1/2 right-2 -translate-y-1/2 cursor-pointer"
            (click)="passwordVisible = !passwordVisible"
          >
            <img
              class="w-[18px] h-[18px]"
              [src]="passwordVisible ? '/assets/icon/password-visible.png' : '/assets/icon/password-invisible.png'"
            />
          </div>
        </div>
        <!-- <nz-input-group>
          <div class="create">
          </div>
        </nz-input-group> -->
      </div>
    </div>
    <div
      class="v4-layout-field"
      *ngIf="showLoginCaptcha()"
    >
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <input
            nz-input
            nzSize="large"
            formControlName="verifyCode"
            [attr.placeholder]="'placeholder.verify_code' | translate"
          />
          <img class="w-[84px] h-[42px] ml-1 rounded-[4px]" [src]="verifyImage"
               (click)="getLoginCaptcha()" alt/>
        </div>
      </div>
    </div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <!-- <iframe [src]="captchaInfo?.safeUrl" frameborder="0"
                style="width: 364px" *ngIf="Platform.FLIGGY === thirdpartyType else other"></iframe>
        <ng-template #other>
        </ng-template> -->
        <div id="aliCode-nc" style="width: 364px"></div>
      </div>
    </div>

    <button
      nz-button
      class="footer"
      nzSize="large"
      [nzType]="'primary'"
      (click)="confirm()"
      [disabled]="isBtnDisabled()"
    >
      {{ 'login.login' | translate }}
      <!-- 登录 -->
    </button>
    <div class="forget-password" (click)="forgetPasswordInfo()">
      <!-- 忘记密码？ -->
      {{ 'channel.forget_password' | translate }}
    </div>
  </ng-container>
</div>

<ng-template #fliggyIframe>
  <iframe class="w-full h-[500px]" *ngIf="fliggyIframeUrl"
          [src]="fliggyIframeUrl"
          frameborder="0"></iframe>
</ng-template>

